import { toast } from "react-toastify"
import { LogoutError } from "./error"

export function errorToastMap(array) {

    const result = Array.isArray(array);

    if (result) {
        // ? map or foreach
        array.forEach((errorMessage) => {
            toast.error(errorMessage)
        })

    } else {
        console.log('errorToastMap is not array', array)
        toast.error('Ошибка №% 3005')
    }
}

type parameters = {
    url: string,
    method: string,
    token: string,
    body?: any
}

export async function restWrapper(parameters: parameters) {
    try {
        const response = await fetch(parameters.url, {
            method: parameters.method,
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
                'token': `Bearer ${parameters.token}`,
            },
            body: parameters.body ? JSON.stringify(parameters.body) : undefined,

        });

        const data = await response.json()

        if (response.status === 403 || response.status === 401) {
            errorToastMap(data?.message)
            throw new LogoutError('Доступ запрещен')
        }

        if (response.status !== 200) {
            errorToastMap(data?.message)
            throw new Error(data.message)
        }

        return {
            data: data,
            status: response.status
        }

    } catch (error) {
        if (error instanceof LogoutError) {
            console.log('restWrapper LogoutError', error.message)
            throw new LogoutError(error.message)
        }

        console.log('restWrapper error message', error.message)
        throw new Error(error.message)
    }

}